module.exports = __webpack_public_path__ + "img/face5.76d8ae01.jpg";